import { DocumentType } from "../../../../@types/enumsGlobal";

export interface IGridStyleItem {
    isKiz?: boolean;
    isKizBox?: boolean;
    countKizScan?: number;
    quantity: number;
    actualQuantity?: number;
    numerator?: number;
    denominator?: number;
    isOsu?: boolean | null;
    isLs?: boolean;
    quantityFrom?: number;
    documentalQuantity?: number;
    kizWithdrawalComplete?: boolean;
    idGlobal?: string;
}

export interface IGridStyleOptions {
    documentType?: DocumentType;
    sysOptionsKizValidationType?: string;
    customKizControl?: (item: any) => boolean;
    getIsLs?: (item: any) => boolean;
}

export const getStyleBorderTr = (
    item: IGridStyleItem,
    options: IGridStyleOptions = {}
): string => {
    const none = 'none';
    const redBorder = '1px solid red';
    
    const {
        documentType,
        sysOptionsKizValidationType,
        customKizControl,
        getIsLs
    } = options;

    const countKizScan: number = item.countKizScan ?? 0;
    const quantity: number = item?.quantity;
    const actualQuantity: number = item?.actualQuantity ?? 0;
    const numerator: number = item.numerator ?? 0;
    const denominator: number = item.denominator ?? 0;
    const isKizOsu: boolean = item.isOsu ?? false;

    if (!item.isKiz && !item.isKizBox) {
        return none;
    }

    if (customKizControl) {
        return customKizControl(item) ? none : redBorder;
    }

    const isLs = getIsLs ? getIsLs(item) : (item.isLs ?? false);

    // Приходная накладная
    if (documentType === DocumentType.invoice) {
        if (!isLs && countKizScan === 1) {
            return none;
        }
        
        // Для дробных КИЗ
        if (numerator < denominator) {
            return (countKizScan !== 1 && !isKizOsu) ? redBorder : none;
        }
        
        // Для целых КИЗ
        const checkQuantity = sysOptionsKizValidationType === 'ActualQuantity' 
            ? actualQuantity 
            : quantity;
        
        return (countKizScan !== checkQuantity && !isKizOsu) ? redBorder : none;
    }

    // Ввод остатков
    if (documentType === DocumentType.importRemains) {
        if (!isLs && countKizScan === 1) {
            return none;
        }
        
        if (numerator < denominator) {
            return (countKizScan !== 1 && !isKizOsu) ? redBorder : none;
        }
        
        return (countKizScan !== quantity && !isKizOsu) ? redBorder : none;
    }

    // Акт разукомплектации
    if (documentType === DocumentType.disassembling) {
        return (countKizScan !== item.quantityFrom) ? redBorder : none;
    }

    // Акт списания
    if (documentType === DocumentType.actDeduction) {
        if (numerator < denominator) {
            return (countKizScan !== 1) ? redBorder : none;
        }
        return (countKizScan !== quantity) ? redBorder : none;
    }

    // Акт возврата поставщику, Акт разагрегации
    if (documentType === DocumentType.actReturnToContractor ||
        documentType === DocumentType.disaggregation) {
        return (countKizScan !== quantity) ? redBorder : none;
    }

    return none;
};

export const isKizCountValid = (
    item: IGridStyleItem,
    options: IGridStyleOptions = {}
): boolean => {
    return getStyleBorderTr(item, options) === 'none';
};


